import Splide from '@splidejs/splide';
import Headroom from "headroom.js";

// header element
var mainHeader = document.querySelector(".main-navigation");

var options = {
  // vertical offset in px before element is first unpinned
  offset: 0,
  // or you can specify offset individually for up/down scroll
  offset: {
    up: 102,
    down: 51
  },
  // scroll tolerance in px before state changes
  tolerance: 0,
  // or you can specify tolerance individually for up/down scroll
  tolerance: {
    up: 5,
    down: 0
  },
  // css classes to apply
  classes: {
    // when element is initialised
    initial: "headroom",
    // when scrolling up
    pinned: "headroom--scrolling-up",
    // when scrolling down
    unpinned: "headroom--scrolling-down",
    // when above offset
    top: "headroom--top",
    // when below offset
    notTop: "headroom--not-top",
    // when at bottom of scroll area
    bottom: "headroom--bottom",
    // when not at bottom of scroll area
    notBottom: "headroom--not-bottom",
    // when frozen method has been called
    frozen: "headroom--frozen",
    // multiple classes are also supported with a space-separated list
    pinned: "headroom--pinned foo bar"
  },
  // callback when pinned, `this` is headroom object
  onPin: function () { },
  // callback when unpinned, `this` is headroom object
  onUnpin: function () { },
  // callback when above offset, `this` is headroom object
  onTop: function () { },
  // callback when below offset, `this` is headroom object
  onNotTop: function () { },
  // callback when at bottom of page, `this` is headroom object
  onBottom: function () { },
  // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom: function () { }
};

var headroom = new Headroom(mainHeader, options);
// initialise Headroom
headroom.init();

// Splide docs: https://splidejs.com/
var testimonialsSliders = document.getElementsByClassName('splide__testimonials');
for (var i = 0, len = testimonialsSliders.length; i < len; i++) {
  new Splide(testimonialsSliders[i], {
    type: "fade",
    rewind: true,
    speed: 600,
    pagination: false,
    autoHeight: true
  }).mount();
}

var testimonialsSliders = document.getElementsByClassName('splide__services');
for (var i = 0, len = testimonialsSliders.length; i < len; i++) {
  var navSlider = new Splide('#' + testimonialsSliders[i].getAttribute('data-nav'), {
    fixedWidth: 100,
    rewind: true,
    gap: 0,
    isNavigation: true,
    pagination: false,
  }).mount();
  new Splide(testimonialsSliders[i], {
    type: "fade",
    rewind: true,
    speed: 600,
    pagination: false,
    arrows: false,
    autoHeight: true,
  }).sync(navSlider).mount();
}

var threeColumnHighlightSliders = document.getElementsByClassName('splide__3-column-highlight');
for (var i = 0, len = threeColumnHighlightSliders.length; i < len; i++) {
  new Splide(threeColumnHighlightSliders[i], {
    type: "slide",
    rewind: true,
    speed: 600,
    pagination: false,
    arrows: false,
    perPage: 3,
    gap: '24px',
    breakpoints: {
      1024: {
        perPage: 2,
        gap: '16px',
      },
      767: {
        perPage: 1,
        gap: '16px',
      }
    }
  }).mount();
}

// Function to fix form anchor link position issue
var repairContainerLink = document.querySelector('[aria-label="Repair a Container"]');
// console.log("debug repare container link");
// console.log(repairContainerLink);
repairContainerLink.addEventListener('click', function(event) {
  window.setTimeout(function() {
    offsetAnchor();
  }, 0);
});
function offsetAnchor() {
  if (location.hash.length !== 0) {
    var top = document.getElementById('form-tabs').offsetTop-document.getElementById("main-navigation").offsetHeight-10;
    var calTop = top - 170;
    window.scrollTo(0, calTop);
  }
}
window.setTimeout(offsetAnchor, 0);
// -----------------END Function----------------------

// This function is for testing scroll Y position
// document.addEventListener('scroll', function(e) {
//   var lastKnownScrollPosition = window.scrollY;
//   console.log("scroll Y position");

//   console.log(lastKnownScrollPosition);

// });
// -----------------END Function----------------------


